<template>
  <div class="table">
    <div class="table-header">
      <div class="table-row">
        <!-- <div class="cell cell-status">
        </div> -->
        <div class="cell cell-large center">
          <!--@click="setSorting('bon')"-->
          SERIE
          <!-- <BaseIcon
            v-if="sortingOn == 'bon'"
            :name="this.isAscending ? 'chevron-up' : 'chevron-down'"
            class="icon"
          /> -->
        </div>
        <div class="cell sort cell-large center" @click="setSorting('ref')">
          Prod. REF
          <BaseIcon
            v-if="sortingOn == 'ref'"
            :name="this.isAscending ? 'chevron-up' : 'chevron-down'"
            class="icon"
          />
        </div>
        <div class="cell cell-large center">Quantity</div>
        <div class="cell sort cell-big" @click="setSorting('date')">
          {{ this.dateLabel ? this.dateLabel : "Date" }}
          <BaseIcon
            v-if="sortingOn == 'date'"
            :name="this.isAscending ? 'chevron-up' : 'chevron-down'"
            class="icon"
          />
        </div>
        <!-- <div class="cell cell-big">Operator</div> -->
        <LoadAmountList
          v-if="hasAmountDropdown"
          :totalItems="totalItems"
          @selectedAmount="selectedAmount"
        />
      </div>
    </div>
    <div class="table-content">
      <div
        class="table-row"
        v-bind:class="{ 'active-line-padding': selectedDHR === dhr }"
        v-for="(dhr, index) in this.DHRecords"
        :key="index"
        @click.exact="selectRow(dhr)"
        @dblclick="viewDhrDetail(dhr)"
      >
        <div class="cell cell-large center">
          {{
            dhr.bonID == ""
              ? dhr.lotID
              : dhr.snummer == "0"
              ? dhr.bonID
              : dhr.snummer
          }}
        </div>
        <div class="cell cell-large center">
          {{ dhr.DHRREF.substring(0, dhr.DHRREF.lastIndexOf("-")) }}
        </div>
        <div class="cell cell-large center">
          {{ dhr.finalAmount ? dhr.finalAmount : dhr.amount }}
        </div>
        <div class="cell cell-big">
          {{ dhr.dateCreated | formatDate }}
        </div>
        <div class="cell">
          <BaseIcon
            name="qrcode"
            class="icon"
            size="lg"
            :class="{ 'light-grey': dhr.approved == 1 }"
          />
        </div>
        <div v-if="isAdmin">
          <div class="cell">
            <a @click="deleteDHF(dhr)">
              <BaseIcon name="trash-alt" class="icon" size="lg" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import MoreTableActions from "@/components/base/MoreTableActions";
import LoadAmountList from "@/components/base/LoadAmountList";

export default {
  components: {
    BaseIcon,
    MoreTableActions,
    LoadAmountList,
  },

  props: {
    dateLabel: String,
    DHRecords: {
      type: Array,
      required: true,
    },
    hasAmountDropdown: {
      type: Boolean,
      default: true,
    },
    totalItems: Number,
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  data() {
    return {
      selectedDHR: null,
      sortingOn: "date",
      isAscending: false,
      isOptionOpen: false,
      openOptions: "",
    };
  },
  methods: {
    selectedAmount(val) {
      this.$emit("selectedAmount", val);
    },
    deleteDHF(dhr) {
      const that = this;
      this.$swal({
        title: "Deleting DHR!",
        text: `Are you sure, this cant be undone!`,
        type: "warning",
        showCancelButton: true,
      }).then(function (data) {
        if (!data.dismiss) {
          const typenr = dhr.bonID == "" ? dhr.lotID : dhr.bonID;
          const url =
            that.$endpoint +
            "production/inprogress/" +
            dhr.DHRID +
            "/" +
            typenr;
          that.$http
            .delete(url)
            .then(function (response) {
              that.$emit("refresh", true);
              that.$swal(
                "dhr deleted!",
                `Your dhr has been successfully deleted.`,
                "success"
              );
            })
            .catch(function (error) {
              console.log(error);
              that.$swal(
                "Oops that went wrong?",
                `This is probably because the dhr already has steps that were started, if you think this is a mistake contact an admin`,
                "error"
              );
            });
        }
      });
    },
    selectRow(dhr) {
      if (this.selectedDHR != dhr) {
        this.isOptionOpen = false;
      }
      this.selectedDHR = dhr;
      this.$emit("selectedRow", dhr);
    },
    viewDhrDetail(dhr) {
      if (dhr.lotID != "") {
        this.$router.push("/production/dhr/" + dhr.DHRID + "/" + dhr.lotID);
      } else {
        this.$router.push("/production/dhr/" + dhr.DHRID + "/" + dhr.bonID);
      }
    },
    openMenu(index) {
      if (this.openOptions != index) {
        this.isOptionOpen = true;
      } else {
        this.isOptionOpen = !this.isOptionOpen;
      }
      this.openOptions = index;
    },
    closeMenu() {
      this.isOptionOpen = false;
      this.openOptions = "";
    },
    setSorting(val) {
      if (this.sortingOn != val) {
        this.isAscending = true;
      } else {
        this.isAscending = !this.isAscending;
      }
      this.sortingOn = val;

      this.$emit("sorting", { on: this.sortingOn, asc: this.isAscending });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/base.scss";
@import "../style/components/tables.scss";
@import "@/style/components/active.scss";

.table-header {
  .table-row {
    .cell.sort {
      cursor: pointer;
    }
  }
}

.status-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;

  &.approved {
    background-color: #e9f9ea;
    color: #2aa328;
  }
  &.completed {
    background-color: #d6e9fc;
    color: #3390f2;
  }
  &.in-progress {
    background-color: #fdecd9;
    color: #d08f40;
  }
}
</style>
